'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var TextInput = _react2['default'].createClass({
  displayName: 'TextInput',

  propTypes: {
    /**
     * Specify the size of the input.
     */
    bsSize: _react.PropTypes.oneOf(['large', 'lg', 'small', 'sm'])
  },

  render: function render() {
    var _this = this;

    var _props = this.props,
        bsSize = _props.bsSize,
        className = _props.className,
        hasAux = _props.hasAux,
        otherProps = (0, _objectWithoutProperties3['default'])(_props, ['bsSize', 'className', 'hasAux']);


    return _react2['default'].createElement('input', (0, _extends3['default'])({}, otherProps, {
      className: (0, _classnames2['default'])('form-control', {
        'has-aux': hasAux,
        'input-lg': bsSize === 'large' || bsSize === 'lg',
        'input-sm': bsSize === 'small' || bsSize === 'sm'
      }, className),
      ref: function ref(input) {
        return _this._input = input;
      },
      type: 'text'
    }));
  },
  getInstance: function getInstance() {
    return this._input;
  }
});

exports['default'] = TextInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/ssc-refer/lib/refer/TextInput.react.js
// module id = 580
// module chunks = 0